import { create } from "zustand"
import { persist } from "zustand/middleware"
import { STORAGE_KEYS } from "../Helper/localStorageHandler"
import { SORT_BY } from "../Utils/Constants/liveCameras"

export const cameraStore = create(
  persist(
    (set) => ({
      layout: "3x3",
      pageSize: 9,
      page: 0,
      selectedCamera: null,
      favorites: [],
      sortBy: SORT_BY.NEW_TO_OLD,

      // Persists the last viewed camera's title and stream URL so they survive reloads.
      cameraTitle: null,
      streamUrl: null,
      // Persist the NVR/playback thing names too so playback survives reloads.
      nvrThingName: null,
      playbackCameraThingName: null,

      setLayout: (layout) => {
        let pageSize = 9
        if (layout === "1x1") pageSize = 1
        else if (layout === "2x2") pageSize = 4
        else if (layout === "2x3") pageSize = 6

        set({ layout, pageSize, page: 0 })
      },

      setPageSize: (pageSize) => {
        let layout = "3x3"
        if (pageSize === 1) layout = "1x1"
        else if (pageSize === 4) layout = "2x2"
        else if (pageSize === 6) layout = "2x3"

        set({ pageSize, layout, page: 0 })
      },

      setPage: (page) => set({ page }),
      setSelectedCamera: (camera) => set({ selectedCamera: camera }),
      clearSelectedCamera: () => set({ selectedCamera: null }),

      toggleFavorite: (cameraTitle) =>
        set((state) => {
          const isFav = state.favorites.includes(cameraTitle)
          const newFavorites = isFav
            ? state.favorites.filter((title) => title !== cameraTitle)
            : [...state.favorites, cameraTitle]
          return { favorites: newFavorites }
        }),

      setSortBy: (sortBy) => set({ sortBy }),

      setCameraTitle: (cameraTitle) => set({ cameraTitle }),
      setStreamUrl: (streamUrl) => set({ streamUrl: streamUrl || null }),
      setNvrThingName: (nvrThingName) =>
        set({ nvrThingName: nvrThingName || null }),
      setPlaybackCameraThingName: (playbackCameraThingName) =>
        set({ playbackCameraThingName: playbackCameraThingName || null }),
    }),
    {
      name: STORAGE_KEYS.CAMERA_STREAM_DETAILS, // Use a unique name for the persisted state
      // Only persist the last viewed camera's title and stream URL.
      partialize: (state) => ({
        cameraTitle: state.cameraTitle,
        streamUrl: state.streamUrl,
        nvrThingName: state.nvrThingName,
        playbackCameraThingName: state.playbackCameraThingName,
      }),
    },
  ),
)
